var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-table" }, [
    _c(
      "div",
      { staticClass: "templates-panel", on: { click: _vm.goToTemplates } },
      [
        _c("div", { staticClass: "panel-header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "panel-title-wrap" }, [
            _c("div", { staticClass: "panel-title" }, [
              _vm._v(_vm._s(_vm.$t("tables.templates.sidebarTitle"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "panel-subtitle" }, [
              _vm._v(_vm._s(_vm.$t("tables.templates.linkSubtitle"))),
            ]),
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "material-icons panel-arrow" }, [
            _vm._v("arrow_forward"),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sector-chips" },
          _vm._l(_vm.sectors, function (s) {
            return _c(
              "div",
              {
                key: s.key,
                staticClass: "sector-chip",
                style: { background: s.bg, color: s.color },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(_vm._s(s.icon)),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.sectorLabel(s.key)))]),
              ]
            )
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "divider" }, [
      _c("span", { staticClass: "divider-line" }),
      _vm._v(" "),
      _c("span", { staticClass: "divider-text" }, [
        _vm._v(_vm._s(_vm.$t("tables.templates.or"))),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "divider-line" }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "blank-section" },
      [
        _c("h4", { staticClass: "blank-title" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("add_box")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("tables.templates.blankTableSectionTitle")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "a-form",
          {
            staticClass: "blank-form",
            attrs: { model: _vm.table, layout: "vertical" },
          },
          [
            _c(
              "a-form-item",
              { attrs: { label: _vm.$t("tables.tableName") } },
              [
                _c("a-input", {
                  attrs: { placeholder: _vm.$t("tables.tableName") },
                  model: {
                    value: _vm.table.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.table, "name", $$v)
                    },
                    expression: "table.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-item",
              { attrs: { label: _vm.$t("tables.description") } },
              [
                _c("a-textarea", {
                  attrs: { rows: 2 },
                  model: {
                    value: _vm.table.description,
                    callback: function ($$v) {
                      _vm.$set(_vm.table, "description", $$v)
                    },
                    expression: "table.description",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-item",
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary", disabled: !_vm.table.name },
                    on: { click: _vm.createTable },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("tables.createTable")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-icon" }, [
      _c("i", { staticClass: "material-icons" }, [
        _vm._v("dashboard_customize"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }